"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = require("../../../theme/styled");

var NavbarBrand = styled_1["default"].div(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    display: 'inline-block',
    margin: 'auto 0',
    '& > img': {
      maxHeight: theme.navbar.logoHeight,
      maxWidth: '100%'
    }
  }, _ref2["@media (max-width: " + theme.navbar.collapseAt + ")"] = {
    padding: 0
  }, _ref2;
});
exports["default"] = NavbarBrand;